module.exports = __webpack_public_path__ + "img/mkt_details_failed.02e3dd27.svg";